<template>
   <v-dialog
      v-model="show"
      max-width="800"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('automap-ingrediens') }}
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-progress-linear
              :active="loading"
              :indeterminate="true"
              height="4"
            />
            <template v-if="!loading">
            <v-subheader class="mb-5">{{ $t('automap-ingrediens-subheader') }} </v-subheader>
              <v-data-table
                :headers="headers"
                :items="data"
                :loading="fetchLoading"
                fixed-header
                hide-default-footer
                disable-pagination
                class="elevation-1"
                max-height="400px"
              >
                <template v-slot:item._selected="{ item }">
                  <v-simple-checkbox
                    v-model="item._selected"
                    :ripple="false"
                  ></v-simple-checkbox>
                </template>
                <template v-slot:footer>
                  <section class="my-6 text-center">
                      <v-btn
                        v-show="!fetchCompleted"
                        color="primary"
                        class="mb-8"
                        text
                        @click="loadMore()"
                        :loading="fetchLoading"
                        :disabled="fetchLoading && fetchCompleted"
                      >
                        Load more
                      </v-btn>
                  </section>
                </template>
              </v-data-table>
            </template>
          </v-container>
        </v-card-text>
        
        <v-card-actions v-show="!loading">
          <v-spacer />
          <v-btn
            text
            @click="onClose"
          >
            {{ $t('cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="onSave"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import Fuse from 'fuse.js'

export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    headers: [
      { text: 'Evaluation', value: 'inciName', align: 'start', sortable: false },
      { text: 'Suggested ingrediens', value: '_cosingName', sortable: false },
      { text: 'Save', value: '_selected', align: 'end', sortable: false },
    ],
    fuse: null,
    fuseOptions: {
      keys: ['inciName', 'casNumber']
    },
    data: [],
    loading: false,

    // pagination
    tableOptions: {},
    fetchLoading: false,
    fetchCompleted: false,
    limit: 10,
  }),
  mounted() {
    this.fuse = new Fuse(this.cosing, this.fuseOptions)
  },
  watch: {
    activeProject: function () {
      this.init();
    },
    show: function (val) {
      this.isOpen = val;
      if(val) {
        this.init();
      }
    },
  },
  computed: {
    company() {
      return this.$store.getters["company/getCompany"];
    },
    activeProject() {
      return this.$store.getters["projects/getActiveProject"];
    },
    cosing() {
      return this.$store.getters["ingredients/getCosing"];
    },
    projectIngredients() {
      return this.$store.getters["projectIngredients/getProjectIngredients"];
    },
    show: {
      get () {
        return this.value
      },
      set (value) {
         this.$emit('input', value)
      }
    },
  },
  methods: {
    init() {
      if(this.activeProject && this.activeProject.id && this.show) {
        this.data = [];
        this.fetchLoading = false;
        this.fetchCompleted = false;
        this.fetchData();
      }
    },
    async fetchData() {
      this.fetchLoading = true;
      const res = await this.$store.dispatch('projectIngredients/fetchEvaluationsWithoutReference', { projectId: this.activeProject.id, limit: this.limit, fromStart: this.data.length <= 0 ? true : false})
      const arr = [];
      res.forEach((item) => {
        const cosing = this.suggestCosing(item);
        if (cosing) {
          item._cosingName = cosing.inciName;
          item._selected = true;
          item.reference = cosing.reference;
        }
        arr.push(item);
      });
      this.fetchLoading = false;
      this.fetchCompleted = arr.length < this.limit ? true : false;
      this.data = this.data.concat(arr);
    },
    loadMore() {
      this.fetchData();
    },
    suggestCosing(item) {
      this.queryCosing(item.inciName)
      return this.searchCosingItems[0];
    },
    queryCosing(search) {
      if (search && search.length >= 2) {
        const res = this.fuse.search(search).slice(0,6)
        this.searchCosingItems = res.map((obj) => { return obj.item });
      } else {
        this.searchCosingItems = [];
      }
    },
    onSave() {
      this.loading = true;
      const arr = [];
      this.data.forEach((item) => {
        if (item._selected) {
          arr.push({ ref: item.ref, id: item.id, reference: item.reference });
        }
      });

      if (arr.length>0) {
        this.$store.dispatch("projectIngredients/batchUpdateEvaluationReference", arr)
          .then(() => {
            this.onClose();
            this.$notify({
              group: "base",
              type: "success",
              title: "Items updated",
              text: "The selected items has been successfully updated.",
            });
            this.loading = false;
          })
          .catch((error) => {
            this.loading = false;
            this.$notify({
              group: "base",
              type: "error",
              title: "Oops, something went wrong",
              text: "That did not go as planned. Nothing has been updated.",
            });
          })
      } else {
        this.loading = false;
         this.$notify({
            group: "base",
            type: "error",
            title: "Oops, something went wrong",
            text: "No ingrediens mapping selected",
          });
      }
    },
    onClose() {
      this.show = false;
    },
  }
}
</script>

<style scoped>
.scroll {
  overflow: auto;
  max-height: 400px;
}
</style>